import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableHeader, TableHeaderColumn } from 'material-ui/Table';

import styles from './styles';
import TcIndexRow from './TcIndexRow';

function TcIndexTable({ rows, errors: _errors }) {
    const [errors, setErrors] = useState(_errors);
    useEffect(() => {
        setErrors(_errors);
    }, [_errors]);

    return (
        <div>
            <Table 
                selectable={false}
            >
                <TableHeader
                    displaySelectAll={false} 
                    adjustForCheckbox={false}
                >
                    <TableHeaderColumn style={styles.headerColSm}>Index</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>IMO</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Vessel Type General*</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Vessel Type*</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>DWT group*</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerCol}>Place from</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerCol}>Region from*</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerCol}>Place to</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerCol}>Region to*</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerCol}>VIA</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Round trip</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Clean</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerCol}>LayCan*</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Duration, d</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Balast bonus, $</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Intake, mt</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>T/C index, $/day*</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerCol}>Last update</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Approve</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Reject</TableHeaderColumn>
                    <TableHeaderColumn style={styles.headerColSm}>Delete</TableHeaderColumn>
                </TableHeader>
                <TableBody 
                    displayRowCheckbox={false}
                >
                    {
                        rows.map((row, countIndex) => (
                            <TcIndexRow 
                                countIndex={countIndex}
                                key={row._id || row.key}
                                hireData={row}
                                errors={errors}
                            />
                        ))
                    }
                </TableBody>
            </Table>
        </div>
    );
}

export default TcIndexTable;



// WEBPACK FOOTER //
// ./app/components/TcIndex/TcIndexTable.jsx